import { Chip } from "@legal-500/legal500-design-system";
import type { Testimonial } from "../../../../api/pipeline.service";
import { formatDateTime } from "@/utils";
import { SentimentChip } from "../../components/SentimentChip";
import styles from "./StatusColumn.module.css";

type StatusColumnProps = {
  item: Testimonial;
};

export function StatusColumn({ item }: StatusColumnProps) {
  const getStatusBadge = () => {
    switch (item.status) {
      case "APPROVED":
        return (
          <Chip size="small" variant="filled" className={styles.statusBadgeApproved}>
            ✓ Approved
          </Chip>
        );
      case "REJECTED":
        return (
          <Chip size="small" variant="filled" className={styles.statusBadgeRejected}>
            ✗ Rejected
          </Chip>
        );
      case "SUSPENDED":
        return (
          <Chip size="small" variant="filled" className={styles.statusBadgeSuspended}>
            Suspended
          </Chip>
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.statusColumn}>
      <div className={styles.statusBadgeContainer}>
        <span className={styles.statusLabel}>Status:</span>
        {getStatusBadge()}
      </div>
      <div className={styles.statusBadgeContainer}>
        <span className={styles.statusLabel}>Sentiment:</span>
        <SentimentChip sentiment={item.sentiment} />
      </div>
      <div className={styles.updatedContainer}>
        <div className={styles.updatedDate}>
          <span className={styles.updatedLabel}>Updated:</span>{" "}
          <span className={styles.updatedValue}>
            {item.updatedAt ? formatDateTime(item.updatedAt) : "—"}
          </span>
        </div>
        {item.updatedBy && (
          <div className={styles.updatedDate}>
            <span className={styles.updatedLabel}>By:</span>{" "}
            <span className={styles.updatedValue}>{item.updatedBy}</span>
          </div>
        )}
      </div>
      <div className={styles.updatedContainer}>
        <div className={styles.updatedDate}>
          <span className={styles.updatedLabel}>Created:</span>{" "}
          <span className={styles.updatedValue}>
            {item.createdAt ? formatDateTime(item.createdAt) : "—"}
          </span>
        </div>
      </div>
    </div>
  );
}
